export const directions = {
  LTR: "LTR",
  BTT: "BTT",
  RTL: "RTL",
  TTB: "TTB"
};